import { create } from 'zustand';

type State = {
    isVisible: boolean;
    imageSrc?: string | null;
    alt?: string | null;
};

type Action = {
    showBanner: (opts: { imageSrc: string; alt?: string }) => void;
    hideBanner: () => void;
    setVisible: (visible: boolean) => void;
};

export const useBannerStore = create<State & Action>((set, get) => ({
    isVisible: false,
    imageSrc: null,
    alt: null,

    showBanner: ({ imageSrc, alt }) => {
        set(() => ({ isVisible: true, imageSrc, alt: alt ?? null }));
    },

    hideBanner: () => {
        set(() => ({ isVisible: false }));
    },

    setVisible: (visible) => {
        set(() => ({ isVisible: visible }));
    },
}));
